import { P } from './Typography.js';
import { styled, css } from 'styled-components';
import { cssVar } from '../theme/variables.js';
import { mediaMobile } from '../constants/styled-utils.js';

const SectionTitle = styled(P).attrs((props) => {
  return {
    ...props,
    as: "h2",
    weight: 600
  };
}).withConfig({
  displayName: "Section__SectionTitle",
  componentId: "sc-b4ef3562-0"
})([
  `font-size:24px;font-style:normal;line-height:32px;letter-spacing:-0.48px;`
]);
const variants = {
  default: css([
    `background:`,
    `;padding:30px;border-radius:24px;`,
    `{padding:24px;}`
  ], cssVar["color-bg-section-primary"], mediaMobile),
  clean: css([
    `background:transparent;padding:0 30px;`,
    `{padding:0;}border-radius:0;`
  ], mediaMobile),
  simple: css([
    `background:transparent;border:1px solid `,
    `;border-radius:12px;padding:12px;`
  ], cssVar["color-border-primary"]),
  primary: css([
    `background-color:`,
    `;padding:30px;border-radius:24px;`
  ], cssVar["color-bg-section-primary"]),
  danger: css([
    `background-color:transparent;padding:30px;border-radius:24px;border:1px dashed #f00;`,
    `{padding:24px;}`,
    `{color:#f00;}`
  ], mediaMobile, SectionTitle)
};
const SectionBox = styled.section.withConfig({
  displayName: "Section__SectionBox",
  componentId: "sc-b4ef3562-1"
})([
  ``,
  ` `,
  ``
], (p) => variants[p.variant ?? "default"], (p) => p.disabled && css([
  `opacity:0.5;pointer-events:none;`
]));
const SectionDescription = styled(P).attrs((props) => {
  return {
    weight: 400,
    size: "sm",
    color: "darkblue",
    ...props
  };
}).withConfig({
  displayName: "Section__SectionDescription",
  componentId: "sc-b4ef3562-2"
})([
  `font-style:normal;line-height:20px;max-width:640px;`
]);
const SectionCard = styled.div.withConfig({
  displayName: "Section__SectionCard",
  componentId: "sc-b4ef3562-3"
})([
  `padding:15px;background:`,
  `;border-radius:10px;`
], cssVar["color-bg-section-primary"]);
const Section = Object.assign(SectionBox, {
  Title: SectionTitle,
  Description: SectionDescription
});

export { Section, SectionCard, Section as default };
//# sourceMappingURL=Section.js.map
